<template>
  <v-row justify="center">
    <v-dialog
      v-model="visible"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        @submit.prevent="handleSubmit"
      >
        <v-card
          v-if="editUser"
          :loading="loading"
        >
          <v-card-title>
            <span class="headline">{{ $t("modal.editUser.title") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert
                    v-if="error"
                    border="left"
                    colored-border
                    type="error"
                    elevation="2"
                  >
                    {{ error }}
                  </v-alert>
                </v-col>

                <!-- name -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.name')"
                    v-model="editUser.name"
                    :rules="[rules.required]"
                  />
                </v-col>

                <!-- email -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.email')"
                    :hint="$t('hint.emailLogin')"
                    readonly
                    disabled
                    persistent-hint
                    v-model="editUser.email"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="editUser.permissions"
                    :items="permissions"
                    :label="$t('label.permissions')"
                    multiple
                    :hint="$t('hint.permissionsDoc')"
                    persistent-hint
                    item-text="name"
                    item-value="permission"
                    return-object
                    small-chips
                    deletable-chips
                    class="text-body-1"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Password -->
                <v-col cols="12">
                  <v-text-field
                    autocomplete="new-password"
                    :label="$t('label.password')"
                    :rules="editUser.password ? passwordRules : []"
                    type="password"
                    :hint="$t('hint.adminPasswordReset')"
                    persistent-hint
                    v-model="editUser.password"
                  />
                </v-col>

                <!-- title -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.title')"
                    v-model="editUser.title"
                  />
                </v-col>

                <!-- phone -->
                <v-col cols="6">
                  <v-text-field
                    :label="$t('label.phone')"
                    v-model="editUser.phone"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="onCancel"
              >{{ $t("label.cancel") }}</v-btn
            >
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
              >{{ $t("label.save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { passwordRules } from "../utils/userUtils";
export default {
  name: "EditUser",
  data() {
    return {
      editUser: {
        ...this.user,
      },
      passwordRules,
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        password: (value) => {
          if (value && value.length > 0) {
            return value.length >= 8 || "Password must be 8 characters long.";
          } else {
            return true;
          }
        },
      },
    };
  },
  props: {
    error: {},
    user: {},
    permissions: {},
    loading: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("onConfirmed", this.editUser);
    },
    onCancel() {
      this.$emit("onCancelled");
    },
  },
};
</script>
